const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();

  if (!res.ok || json.failure) {
    throw new Error(json.em || json.message || 'Request failed');
  }

  return json;
};

const unwrap = (json: any) => {
  return json?.result || json?.data || json;
};

const rows = (json: any) => {
  const x = unwrap(json);
  const sd = x?.sd || json?.sd || json?.data?.sd || json?.result?.sd;
  return Array.isArray(sd) ? sd : [];
};

const objectResult = (json: any) => {
  const x = unwrap(json);
  return x?.sd?.[0] || x?.sd || x || {};
};

export const fetchBudgetConsolidationCards = async () =>
  objectResult(await postBiz({ s: 'budgetconsolidation', a: 'cards' }));

export const fetchBudgetConsolidationAccount = async () =>
  rows(await postBiz({ s: 'budgetconsolidation', a: 'account' }));

export const fetchBudgetConsolidationCostCenter = async () =>
  rows(await postBiz({ s: 'budgetconsolidation', a: 'costcenter' }));
